/**
 *
 * Asynchronously loads the component for InterventionPage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
